// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MacCommandFilledSvg from "@ant-design/icons-svg/es/asn/MacCommandFilled";
import AntdIcon from '../components/AntdIcon';

var MacCommandFilled = function MacCommandFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MacCommandFilledSvg
  }));
};

MacCommandFilled.displayName = 'MacCommandFilled';
export default /*#__PURE__*/React.forwardRef(MacCommandFilled);